import React from "react";
import "./RelatedRailForPlayer.scss";
// import Button from "../Button/Button";
import { useSelector } from "react-redux";
import RailContainer from "../../containers/RailContainer";
// import styled from "styled-components";

const RelatedRailForPlayer = ({ setRelatedRailShown, relatedRailShown, assetDetailsForRelatedRailInPlayer = {}, theme = {}, seriesId, type, uid }) => {
  // const { appMessages = {} } = useSelector(store => store.appConfigReducers)
  const playerFeature = useSelector((store) => store.featuresReducers.playerFeature);
  const relatedComponentFull = playerFeature?.relatedComponent?.[0]?.[0];

  let relatedComponent;
  if (relatedComponentFull?.sysId) {
    const relatedComponentContent = relatedComponentFull?.contents?.[0] || {};
    relatedComponent = { ...relatedComponentFull, ...relatedComponentContent };
  } else {
    return <></>
  }

  const { movieSeriesId, detailsSectionData, dataLoading, identityProvider, pageName } = assetDetailsForRelatedRailInPlayer;

  let visibilityStyle = { opacity: 0, pointerEvents: "none" };
  if (relatedRailShown) visibilityStyle = { opacity: 1, pointerEvents: "all" };
  return (
    <div className="RelatedRailForPlayerWrapper" style={visibilityStyle}>
      <RailContainer
        {...{ mediaId: movieSeriesId || seriesId, detailsSectionData, dataLoading, identityProvider, pageName }}
        isPlayerRecommendationRail
        playerRelatedComponent={{ ...relatedComponent, pageNameX: assetDetailsForRelatedRailInPlayer.pageName, typeX: assetDetailsForRelatedRailInPlayer.pageName === "films" ? "m" : "s" }}
        watchLaterClick={() => setRelatedRailShown(false)}
        seriesId={seriesId}
        type={type}
        uid={uid}
      />
      {/* <ButtonStylingWrapper theme={theme}>
        <Button onClick={() => setRelatedRailShown(false)} text={appMessages?.label_may_be_later || "Maybe later"} />
      </ButtonStylingWrapper> */}
    </div>
  );
};

// const ButtonStylingWrapper = styled.div`
//   .button-wrapper__btn {
//     background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.normal.background};
//     color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.normal.text};
//     border: solid 1px ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.normal.stroke};

//     &:hover {
//       background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.focussed.background};
//       color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.focussed.text};
//       border: solid 1px ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.focussed.stroke};
//     }
//     &.active {
//       background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.selected.background};
//       color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle.selected.text};
//     }
//   }
// `;

export default RelatedRailForPlayer;
